export const Api = "https://xnjbmxjgtn.us-east-1.awsapprunner.com/v1/";
// export const Api = "http://localhost:5000/v1/";
// export const Api = process.env.REACT_APP_API_URL;

